// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { Button } from 'vant';

import {
  Collapse, CollapseItem, Col, Row, Tab, Tabs, Cell, CellGroup, Tabbar,
  TabbarItem,
  NavBar,
  Swipe,
  SwipeItem,
  DropdownMenu,
  DropdownItem, Popup, NoticeBar, Icon, Dialog, RadioGroup, Radio, Checkbox, CheckboxGroup, Toast, Form, Field

} from 'vant';

import '../static/global.css' /*引入公共样式*/
import wx from "weixin-js-sdk";
import router from './router'

var whiteList = ['memberAppGuideList', 'appProfile', 'appServiceAgreement',
  "appCancellation", 'appInvoiceAgreement', 'paymentInvite', 'lottery', 'lotteryPay']

Vue.use(Button);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Col);
Vue.use(Row);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(NavBar);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Popup);
Vue.use(NoticeBar);
Vue.use(Icon);
Vue.use(Dialog);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Toast);
Vue.use(Form);
Vue.use(Field);
Toast.setDefaultOptions({ duration: 3000 });
/* eslint-disable no-new */

router.beforeEach((to, from, next) => {
  // alert(to.name)
  console.log("to:", to)
  // alert(from.name)
  console.log('from', from)
  // alert(window.navigator.userAgent.toLowerCase())
  // alert(whiteList.indexOf(to.name))
  if (to.meta.title) {
    // alert(to.meta.title)
    document.title = to.meta.title
    // alert(document.title)
  }
  if (whiteList.indexOf(to.name) == -1) {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      //微信环境下
      // alert('微信环境下')
      wx.miniProgram.getEnv(function (res) {
        if (res.miniprogram) {
          // 小程序环境下逻辑
          // alert('小程序环境下逻辑')

          next()
        } else {
          //非小程序环境下逻辑
          // alert('非小程序环境下逻辑')

          next('/paymentInvite')
        }
      });
    } else {
      //不是微信环境
      // alert('不是微信环境')
      next('/paymentInvite')
    }
  } else {
    //是白名单
    // alert('是白名单')

    next()
  }
})

const app = new Vue({
  router,
  ...App,
})

  .$mount('#app');




// WEBPACK FOOTER //
// ./src/main.js